
<wdm-header-root *ngIf="showHeader"></wdm-header-root>
<router-outlet></router-outlet>

